import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useActionsStore = defineStore('actionsStore', {
  state: () => ({
    endpoint: 'actions',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
